import { useTranslation } from "react-i18next";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

const Auth0Error = () => {
  const { t } = useTranslation();
  const auth0 = useAuth0();

  const params = new URLSearchParams(window.location.search);
  const message = params.get("error_description") || "error_default";

  const logout = async () => {
    try {
      window.localStorage.clear();
    } catch {}

    try {
      // Bug real (auditoría 2026-08-14): auth0.logout() ya redirige el
      // browser al /v2/logout de Auth0 (window.location.assign) — el
      // window.location.href = '/' que corría siempre después, apenas se
      // resolvía la promesa de logout() (que resuelve casi enseguida,
      // mucho antes de que el browser llegue a ejecutar esa navegación
      // pendiente), le ganaba la carrera y la cancelaba. La sesión quedaba
      // viva en el IdP aunque la app pareciera deslogueada — problema real
      // de privacidad en computadoras compartidas. useUser.js ya hace
      // logout así de bien (sin redirect propio después).
      await auth0.logout({ returnTo: window.location.origin })
      return
    } catch {}

    try {
      window.location.href = '/'
    } catch {}
  }

  const email = auth0.user?.email

  return (
    <div className="vh-100 d-flex flex-column justify-content-center align-items-center">
      <div>
        <h4>{t(`${message}_title`)}</h4>
        <p>
          {t(`${message}_message`)}
        </p>
        <div>
          {auth0.isAuthenticated ? (
            // Fix responsive (2026-08-14): el botón centrado sin max-width
            // crecía a lo ancho de todo el email sin límite (align-items:
            // center no lo acota), y el div truncado sin min-width:0 no
            // podía achicarse por debajo de su contenido — un email largo
            // desbordaba la pantalla en vez de truncar con "…".
            <button
              className="py-3 px-0 btn btn-link link-danger text-start text-nowrap d-flex"
              style={{ maxWidth: '90vw' }}
              onClick={logout}
            >
              {t("logout", 'Cerrar sesion')}
              {!!email && (
                <div className="text-secondary text-truncate ms-2" style={{ minWidth: 0 }}>{email}</div>
              )}
            </button>
          ) : (
            <a href="/">{t("home")}</a>
          )}
        </div>
      </div>
    </div>
  );
};

export default Auth0Error;
